/* eslint-disable import/prefer-default-export */

export const DEAL_LIST_UPDATE = 'DEAL_LIST_UPDATE';
export const DEAL_UPDATE = 'DEAL_UPDATE';
export const FILTER_UPDATE = 'FILTER_UPDATE';
export const UPDATE_STATUS = 'DEAL_STATUS_UPDATE';
